import Vue from 'vue'
import Vuex from 'vuex'
import { getInfo } from '@/api/login'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    account: {
      isLogin: false,
      token: localStorage.getItem('token') || '',
      username: '',
      name: '',
      avatar: '',
      type: 0,
      classname: '',
      nav: ''
    }
  },
  mutations: {
    updateLoginState(state, { isLogin, info }) {
      state.account.isLogin = isLogin
      if (info) {
        state.account.username = info.username || ''
        state.account.name = info.name || ''
        state.account.avatar = info.avatar || ''
        state.account.type = info.type || 0
        state.account.classname = info.classname || ''
      }
      if (!isLogin && window.location.pathname !== '/') {
        window.location.href = '/'
      }
    },
    logout(state) {
      state.account.isLogin = false
      localStorage.removeItem('token')
      if (window.location.pathname !== '/') {
        window.location.href = '/'
      }
    },
    login(state, { token }) {
      state.account.isLogin = true
      state.account.token = token
      localStorage.setItem('token', token)
    }
  },
  actions: {
    async checkLogin({ state, commit }) {
      if (!state.account.token) {
        commit('logout')
        return false
      }
      try {
        const response = await getInfo()
        const { data } = response
        if (data) {
          commit('updateLoginState', { isLogin: true, info: data })
          return true
        } else {
          commit('updateLoginState', { isLogin: false })
          return false
        }
      } catch (error) {
        commit('updateLoginState', { isLogin: false })
        return false
      }
    }
  }
})

export default store
